import { render, staticRenderFns } from "./PackItem.vue?vue&type=template&id=284d4950&"
import script from "./PackItem.vue?vue&type=script&lang=js&"
export * from "./PackItem.vue?vue&type=script&lang=js&"
import style0 from "./PackItem.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports